import React from "react";
import { Translate } from "components/common/Translate/Translate";
import dynamic from "next/dynamic";

const CropImageFreeWithOnlineImagePreview = dynamic<{image?: string}>(
    () => import("@/components/features/CropImage/CropImageFreeWithOnlineImagePreviewImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);

const CropImagePerfectYourImageImagePreview = dynamic<{image?: string}>(
    () => import("@/components/features/CropImage/CropImagePerfectYourImageImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);

export const CropImageFreeWithOnline = ({image}: {image?:string}) => {
    return (
        <>
            <div className="flex flex-col md:flex-row items-center ">
                <div className="flex-1 gap-2 hidden md:block">
                    <CropImageFreeWithOnlineImagePreview image={image} />
                </div>
                <div className="flex-1 dark:text-white text-center md:text-left">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="Interactive-Cropping-Interface-title"/>
                    </h2>
      
                    <p className="md:pt-6 md:mt-1 mt-5">
                        <Translate keyName="Interactive-Cropping-Interface-subtitle" />
                    </p>
                    <div className="flex-1 gap-2 md:hidden">
                    <CropImageFreeWithOnlineImagePreview image={image} />
                    </div>
                </div>
            </div>

            <div className="flex flex-col md:flex-row items-center mt-20">
                <div className="flex-1 dark:text-white text-center md:text-left order-2 md:order-1">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="Perfect-Your-Images-with-Custom-Ratios-title" />
                    </h2>
                    <p className="md:pt-6 md:mt-1 mt-5">
                        <Translate keyName="Perfect-Your-Images-with-Custom-Ratios-subtitle" />
                    </p>
                    <div className="flex-1 gap-2 md:hidden">
                        <CropImagePerfectYourImageImagePreview image={image} />
                    </div>
                </div>
                <div className="flex-1 gap-2 hidden md:block order-1 md:order-2">
                    <CropImagePerfectYourImageImagePreview image={image} />
                </div>
            </div>
        </>
    )
};

